'use strict';

import React from 'react'
import ReactDOM from 'react-dom'

/**
 * parameters:
 *
 * className: a string of classes to add to the input element
 * value: the amount of seconds
 * onChange: function (seconds) 
 */
export class DurationInput extends React.Component {

  constructor(props) {
    super(props);

    this.inputElement = React.createRef();

    this.currently_editing = null;

    this.text_value = {
      hours: '00',
      minutes: '00',
      seconds: '00',
    }

    this.focusing_with_mouse = false;
  }

  componentDidUpdate = () => {
    let input_element = ReactDOM.findDOMNode(this);
    if (document.activeElement == input_element) { // Important for Safari, otherwise updating the selection triggers the focus to come back to this element.
      input_element.selectionStart = this.selection_start;
      input_element.selectionEnd = this.selection_end;
    }
  }

  getValueDisplay = () => {

    let seconds = Math.round(this.props.value);
    let minutes = Math.floor(seconds / 60);
    let hours = Math.floor(minutes / 60);
    let remaining_minutes = minutes % 60;
    let remaining_seconds = seconds % 60;

    // The currently_editing variable ensures we don't convert an
    // en-space to a leading zero too early.
    let currently_editing_name = this.getSectionName(this.currently_editing);
    if (currently_editing_name != 'hours') {
      this.text_value.hours = (hours + 100).toString().slice(-2);
    }
    if (currently_editing_name != 'minutes') {
      this.text_value.minutes = (remaining_minutes + 100).toString().slice(-2);
    }
    if (currently_editing_name != 'seconds') {
      this.text_value.seconds = (remaining_seconds + 100).toString().slice(-2);
    }

    let value_display;
    if (this.props.format == 'MM:SS') {
      if (hours == 0) {
        value_display = this.text_value.minutes + ':' + this.text_value.seconds;
      }
      else {
        value_display = this.text_value.hours + ':' + this.text_value.minutes + ':' + this.text_value.seconds;
      }
    }
    else if (this.props.format == 'HH:MM:SS') {
      value_display = this.text_value.hours + ':' + this.text_value.minutes + ':' + this.text_value.seconds;
    }
    else if (this.props.format == 'HH:MM') {
      value_display = this.text_value.hours + ':' + this.text_value.minutes;
    }

    return value_display;
  }

  incrementValue = (current_selected_section, increment_amount) => {

    this.currently_editing = null;

    let time_value = this.getSecondsFromTextValue();

    var new_value;
    if (this.props.format == 'MM:SS' || this.props.format == 'HH:MM:SS') {
      if (current_selected_section == 1) {
        time_value += increment_amount;
      }
      else if (current_selected_section == 2) {
        time_value += increment_amount * 60;
      }
      else {
        time_value += increment_amount * 3600;
      }
    }
    else if (this.props.format == 'HH:MM') {
      if (current_selected_section == 1) {
        time_value += increment_amount * 60;
      }
      else if (current_selected_section == 2) {
        time_value += increment_amount * 3600;
      }
    }

    // Ensure we don't go below 0;
    // Ensure we don't go above 59:59 if not displaying hours.
    if (time_value >= 0 && !(this.props.format == "MM:SS" && time_value >= 3600)) {
      this.props.onChange(time_value);
    }

  }

  getSecondsFromTextValue = () => {
    let hours = (this.text_value.hours != '\u2002\u2002') ? parseInt(this.text_value.hours) * 3600 : 0;
    let minutes = (this.text_value.minutes != '\u2002\u2002') ? parseInt(this.text_value.minutes) * 60 : 0;
    let seconds = (this.text_value.seconds != '\u2002\u2002') ? parseInt(this.text_value.seconds) : 0;
    return hours + minutes + seconds;
  }

  updateTimeValue = () => {
    this.props.onChange(this.getSecondsFromTextValue());
  }

  getSectionName = (section_number) => {
    let current_selected_section_name;
    if (this.props.format == 'MM:SS' || this.props.format == 'HH:MM:SS') {
      if (section_number == 1) {
        current_selected_section_name = 'seconds';
      }
      else if (section_number == 2) {
        current_selected_section_name = 'minutes';
      }
      else if (section_number == 3) {
        current_selected_section_name = 'hours';
      }
    }
    else if (this.props.format == 'HH:MM') {
      if (section_number == 1) {
        current_selected_section_name = 'minutes';
      }
      else if (section_number == 2) {
        current_selected_section_name = 'hours';
      }
    }
    return current_selected_section_name;
  }

  handleNumberPressed = (number, current_selected_section, element) => {

    // This alters the selected section based on whether there are spaces in
    // the section or not. If there are any spaces, it means the number has
    // not been completly filled in, so when the user enters a number we
    // remove the leading space and add the new digit to the right. If 2
    // numbers have already been entered, we assume this is a new number being
    // entered. For example, if the value is '2' we assume the
    // user intends to add a second digit.
    //
    // Leaving a single digit with a leading space is valid as we can later
    // treat a space as a leading zero.

    let current_selected_section_name = this.getSectionName(current_selected_section);

    if (this.text_value[current_selected_section_name][0] == '\u2002') {
      // Condition is a space and a number. Remove the space and add the new
      // number to the end.
      this.text_value[current_selected_section_name] = this.text_value[current_selected_section_name][1] + number;
    }
    else {
      // Condition is 2 numbers. Replace with a single en-space and the
      // inputted number.
      this.text_value[current_selected_section_name] = '\u2002' + number;
    }

    this.updateTimeValue();

    this.highlightSection(current_selected_section, element, current_selected_section);
  }

  handleDeletePressed = (current_selected_section, element) => {
    let current_selected_section_name = this.getSectionName(current_selected_section);
    if (this.text_value[current_selected_section_name][0] == '\u2002') {
      this.text_value[current_selected_section_name] = '\u2002\u2002';
      this.updateTimeValue();
      this.highlightSection(current_selected_section_name, element, current_selected_section_name);
    }
    else {
      this.text_value[current_selected_section_name] = '\u2002' + this.text_value[current_selected_section_name][0];
      this.updateTimeValue();
      this.highlightSection(current_selected_section_name, element, current_selected_section_name);
    }
  }

  highlightSection = (section, element, currently_editing) => {

    this.currently_editing = currently_editing;

    let start;
    let end;

    if (element.value.length < 6) {
      if (section == 1) {
        start = 3;
        end = 5;
      }
      else if (section == 2) {
        start = 0;
        end = 2;
      }
    }
    else {
      if (section == 1) {
        start = 6;
        end = 8;
      }
      else if (section == 2) {
        start = 3;
        end = 5;
      }
      else if (section == 3) {
        start = 0;
        end = 2;
      }
    }

    element.setSelectionRange(start, end);
    this.selection_start = start;
    this.selection_end = end;

  }

  /**
   * Choose whether to default to highlighting hours, minutes or
   * seconds.
   *
   * A user will likely not want to alter seconds all the time, but
   * if they already have altered seconds they will be likely to want
   * to edit them. Therefore we default to highlighting seconds then
   * minutes, unless they are set to zero.
   */
  getDefaultSelectedSection = () => {
    if (this.text_value.seconds == '00') {
      return 2;
    }
    else {
      return 1;
    }
  }

  getCurrentSelectedSection = (element) => {

    let section;
    if (element.value.length < 6) {
      if (element.selectionEnd < 3) {
        section = 2;
      }
      else {
        section = 1;
      }
    }
    else {
      if (element.selectionEnd < 3) {
        section = 3;
      }
      else if (element.selectionEnd < 6) {
        section = 2;
      }
      else {
        section = 1;
      }
    }

    return section;

  }

  handleKeyDown = (event) => {

    let current_selected_section = this.getCurrentSelectedSection(event.target);

    switch (event.key) {
      case "Tab":
        // Allow default behaviour here (avoid returning preventDefault being
        // called below).
        break;
      case "Up": // IE/Edge specific value
      case "ArrowUp":
        this.incrementValue(current_selected_section, 1);
        event.preventDefault();
        event.stopPropagation();
        break;
      case "Down": // IE/Edge specific value
      case "ArrowDown":
        this.incrementValue(current_selected_section, -1);
        event.preventDefault();
        event.stopPropagation();
        break;
      default:
        // Entering most characters can cause the cursor to move to the wrong
        // position, so our default is to cancel the default behaviour.
        event.preventDefault();
        break;
    }

  }

  handleKeyUp = (event) => {

    event.stopPropagation();

    let current_selected_section = this.getCurrentSelectedSection(event.target);

    switch (event.key) {

      case '0':
      case '1':
      case '2':
      case '3':
      case '4':
      case '5':
      case '6':
      case '7':
      case '8':
      case '9':
        this.handleNumberPressed(event.key, current_selected_section, event.target);
        event.preventDefault();
        break;

      case "Left":
      case "ArrowLeft":
        if (current_selected_section == 2) {
          this.highlightSection(3, event.target, null);
          this.updateTimeValue();
        }
        else if (current_selected_section == 1) {
          this.highlightSection(2, event.target, null);
          this.updateTimeValue();
        }
        event.preventDefault();
        break;

      case ":": // Pressing colon goes to the next section.
      case "Right":
      case "ArrowRight":
        if (current_selected_section == 3) {
          this.highlightSection(2, event.target, null);
          this.updateTimeValue();
        }
        else if (current_selected_section == 2) {
          this.highlightSection(1, event.target, null);
          this.updateTimeValue();
        }
        event.preventDefault();
        break;

      case "Backspace":
        this.handleDeletePressed(current_selected_section, event.target);
        event.preventDefault();
        break;

      case "Enter":
        if (this.props.onEnterPress) {
          this.props.onEnterPress();
        }
        break;
    }
  }

  handleMouseDown = (event) => {
    this.focusing_with_mouse = true;
  }

  handleFocus = (event) => {
    if (!this.focusing_with_mouse) {
      let current_selected_section = this.getDefaultSelectedSection(event.target);
      let target = event.target;

      // Safari highlights all text even if we set preventDefault here, so as
      // a workaround we have to use a setTimeout so that we can highlight the
      // correct section after Safari has done its own highlighting.
      setTimeout(() => {
        this.highlightSection(current_selected_section, target, null)
      }, 0);

      this.focusing_with_mouse = false;
      event.preventDefault();
    }
  }

  focus = () => {
    this.inputElement.current.focus();
  }

  select = () => {
    this.focus()
  }

  handleClick = (event) => {
    let current_selected_section = this.getCurrentSelectedSection(event.target);
    this.highlightSection(current_selected_section, event.target, null);
    event.stopPropagation();
  }

  handleBlur = (event) => {

    // Sort out any missing zeros.
    this.currently_editing = null;
    this.updateTimeValue();

    // Resetting this value ready for when focus is returned.
    this.focusing_with_mouse = false;

    // Remove the selection. This can reappear even when the element does not
    // have focus otherwise. For example, after clicking the save button.
    if (window.getSelection().removeAllRanges) {
      window.getSelection().removeAllRanges();
    }

  }

  render () {

    let style = { width: '4.4em' };
    if (this.props.style) {
      style = Object.assign(style, this.props.style)
    }

    return (
      <input
        pattern="[0-9]*" // number virtual keyboard for iOS
        inputMode="numeric" // number virtual keyboard for other browsers
        type="text"
        readOnly={(this.props.readOnly) ? true : false}
        disabled={(this.props.disabled) ? true : false}
        ref={this.inputElement}
        className={this.props.className}
        value={this.getValueDisplay()}
        onChange={function () {} } // Actually using the keydown method instead. But we need to set this because defaultValue won't update when changing, and readOnly stops iPad keyboard from showing.
        style={style}
        onKeyDown={this.handleKeyDown}
        onKeyUp={this.handleKeyUp}
        onFocus={this.handleFocus}
        onBlur={this.handleBlur}
        onMouseDown={this.handleMouseDown}
        onClick={this.handleClick}
      />
    );
  }

}
